module.exports = __webpack_public_path__ + "static/media/loading-spin.6e147245.svg";